
// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
// eslint-disable-next-line no-extend-native
export function formatDate(date, fmt) {
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  }
  return fmt
}

/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function formatDuration(seconds) {
  seconds = parseInt(seconds)
  const d = Math.floor(seconds / (3600 * 24))
  const h = Math.floor(seconds % (3600 * 24) / 3600)
  const m = Math.floor(seconds % 3600 / 60)
  const s = Math.floor(seconds % 60)

  const dDisplay = d > 0 ? d + '天' : ''
  const hDisplay = h > 0 ? h + '时' : ''
  const mDisplay = m > 0 ? m + '分' : ''
  const sDisplay = s > 0 ? s + '秒' : ''
  return dDisplay + hDisplay + mDisplay + sDisplay
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

export function htmlUnescape(html) {
  return html.replace(/&lt;|&gt;|&quot;|&amp;/g, match => {
    switch (match) {
      case '&lt;':
        return '<'
      case '&gt;':
        return '>'
      case '&quot;':
        return '"'
      case '&#39;':
        return "'"
      case '&amp;':
        return '&'
    }
  })
}

export function postMessage(msg, iframeId) {
  if (!iframeId) {
    iframeId = 'window-edit'
  }
  const frame = window.document.getElementById(iframeId)
  frame.contentWindow.postMessage(msg, '*')
}

export function digitToRoman(num = 1) {
  const legend = { 1: 'I', 2: 'II', 3: 'III', 4: 'IV', 5: 'V', 6: 'VI',
    7: 'VII', 8: 'VIII', 9: 'IX', 10: 'X', 20: 'XX', 30: 'XXX', 40: 'XL', 50:
  'L', 60: 'LX', 70: 'LXX', 80: 'LXXX', 90: 'XC', 100: 'C', 200: 'CC', 300:
  'CCC', 400: 'CD', 500: 'D', 600: 'DC', 700: 'DCC', 800: 'DCCC', 900: 'CM',
    1000: 'M', 2000: 'MM', 3000: 'MMM', 4000: 'MMMM', 5000: 'MMMMM', 6000:
  'MMMMMM', 7000: 'MMMMMMM', 8000: 'MMMMMMMM', 9000: 'MMMMMMMMM' }
  const arr = num.toString().split('').reverse()
  let i = 1; let k
  for (k = 0; k < arr.length; k++) {
    arr.splice(k, 1, arr[k] * i)
    i *= 10
  }
  const romansArray = []
  for (i = 0; i < arr.length; i++) {
    romansArray.push(legend[arr[i]] || '')
  }
  return romansArray.reverse().join('')
}

export function digitToChinese(num = 1) {
  if (!/^\d*(\.\d*)?$/.test(num)) {
    alert('Number is wrong!')
    return 'Number is wrong!'
  }
  // eslint-disable-next-line no-array-constructor
  const AA = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const BB = ['', '十', '百', '千', '万', '亿', '点', '']
  const a = ('' + num).replace(/(^0*)/g, '').split('.')
  let k = 0
  let re = ''
  for (let i = a[0].length - 1; i >= 0; i--) {
    switch (k) {
      case 0:
        re = BB[7] + re
        break
      case 4:
        if (!new RegExp('0{4}\\d{' + (a[0].length - i - 1) + '}$').test(a[0])) { re = BB[4] + re }
        break
      case 8:
        re = BB[5] + re
        BB[7] = BB[5]
        k = 0
        break
    }
    if (k % 4 === 2 && a[0].charAt(i + 2) !== 0 && a[0].charAt(i + 1) === 0) re = AA[0] + re
    if (a[0].charAt(i) !== 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re
    k++
  }
  if (a.length > 1) { // 加上小数部分(如果有小数部分)
    re += BB[6]
    for (let i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)]
  }
  return re
}

export function html2text(htmlStr) {
  if (!htmlStr) return ''
  // const text = htmlStr.replace(/<[^>]*>/g, '')

  const doc = new DOMParser().parseFromString(htmlStr, 'text/html')
  const text = (doc.body.textContent || '').trim()
  return text
}

// 判断两个区间是否相交
export function isIntersect(arr1, arr2) {
  const start = [Math.min(arr1[0], arr1[1]), Math.min(arr2[0], arr2[1])]// 区间的两个最小值
  const end = [Math.max(arr1[0], arr1[1]), Math.max(arr2[0], arr2[1])]// 区间的两个最大值
  return Math.max(start[0], start[1]) <= Math.min(end[0], end[1])// 最大值里的最小值 是否 小于等于 最大值的最小值
}

/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export function humanFileSize(bytes, si = true, dp = 1) {
  const thresh = si ? 1000 : 1024

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B'
  }

  const units = si
    ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  let u = -1
  const r = 10 ** dp

  do {
    bytes /= thresh
    ++u
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1)

  return bytes.toFixed(dp) + ' ' + units[u]
}

export function formatMoney(value) {
  if (!value) value = 0
  const a = Number(value)
  const b = a.toLocaleString('zh', {
    style: 'currency',
    currency: 'CNY',
    useGrouping: false
  })

  return b
}

// Debounce
export function debounce(func, time) {
  time = time || 100 // 100 by default if no param
  let timer
  return function(event) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(func, time, event)
  }
}

export function isMobileScreen() {
  const WIDTH = 768
  const rect = document.body.getBoundingClientRect()
  return rect.width - 1 <= WIDTH
}

export function stringInsertChar(str, n, char) {
  let result = ''
  for (let i = 0; i < str.length; i++) {
    if (i % n === 0 && i !== 0) {
      result += char + str[i]
    } else {
      result += str[i]
    }
  }
  return result
}

export function isWechat() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  // alert(userAgent)
  // eslint-disable-next-line eqeqeq
  const isWechat = userAgent.match(/MicroMessenger/i) == 'micromessenger'
  // alert(userAgent.match(/MicroMessenger/i))
  // alert(isWechat)
  return isWechat
}

export function isWinWechat() {
  const ua = window.navigator.userAgent.toLowerCase()
  // eslint-disable-next-line eqeqeq
  return (ua.match(/windowswechat/i) == 'windowswechat')
}

export function isMobWechat() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  // eslint-disable-next-line eqeqeq
  const isWechat = userAgent.match(/MicroMessenger/i) == 'micromessenger'

  return isMobile() && isWechat
}

export function isMobile() {
  const userAgent = window.navigator.userAgent.toLowerCase()

  // eslint-disable-next-line eqeqeq
  const bIsIpad = userAgent.match(/ipad/i) == 'ipad'
  // eslint-disable-next-line eqeqeq
  const bIsIphoneOs = userAgent.match(/iphone os/i) == 'iphone os'
  // eslint-disable-next-line eqeqeq
  const bIsMidp = userAgent.match(/midp/i) == 'midp'
  // eslint-disable-next-line eqeqeq
  const bIsUc7 = userAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
  // eslint-disable-next-line eqeqeq
  const bIsUc = userAgent.match(/ucweb/i) == 'ucweb'
  // eslint-disable-next-line eqeqeq
  const bIsAndroid = userAgent.match(/android/i) == 'android'
  // eslint-disable-next-line eqeqeq
  const bIsCE = userAgent.match(/windows ce/i) == 'windows ce'
  // eslint-disable-next-line eqeqeq
  const bIsWM = userAgent.match(/windows mobile/i) == 'windows mobile'

  const isMobile = bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM

  return isMobile
}

export function isMobBaidu() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return /baiduboxapp/.test(userAgent)
}

export function openUrl(url) {
  const noPop = false // isMobBaidu() || isMobWechat()
  if (noPop) {
    window.location.href = url
  } else {
    window.open(url, '_blank')
  }
}

// pc端会重新打开一个窗口，微信手机端会不会重新打开窗口，返回时，列表页设置了keepAlive，就不会刷新
export function openPage(param, vm) {
  // vm.$router.push(param)

  const noPop = isMobWechat() // isMobBaidu()
  if (noPop) {
    vm.$router.push(param)
  } else {
    const to = vm.$router.resolve(param)
    window.open(to.href, '_blank')
  }
}

export async function showUpgradeDlg(vm, permName, detail = null) {
  if (!detail) {
    detail = `当前版本不支持，升级账号，解锁更多功能！`
  }
  const priceLink = `<a class='has-text-primary' href='//bahuyun.com/bd-price.html#${permName}' target='_blank'>查看会员特权</a>`
  try {
    const action = await vm.$msgbox({
      title: '',
      dangerouslyUseHTMLString: true,
      message: `<div>${detail}</div><div class='my-5'>${priceLink}</div>`,
      iconClass: 'iconfont icon-lock has-bg-danger upgrade-icon',
      confirmButtonText: '升级使用',
      confirmButtonClass: 'el-button--success ',
      center: true
    })

    console.log(action) // confirm
    const orgId = localStorage.getItem('bd_webapp_orgId')
    openPage({
      name: 'OrderCreate',
      query: { org_id: orgId }
    }, vm)
  } catch (error) {
    console.log(error)
  }
}

export function isIOS() {
  const userAgent = typeof window.navigator !== 'undefined' && window.navigator.userAgent || ''
  // let isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
  const isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent)
  return isIOS
}

//  Formatted version of a popular md5 implementation
//  Original copyright (c) Paul Johnston & Greg Holt.
//  The function itself is now 42 lines long.
export function md5(inputString) {
  const hc = '0123456789abcdef'
  function rh(n) { let j; let s = ''; for (j = 0; j <= 3; j++) s += hc.charAt((n >> (j * 8 + 4)) & 0x0F) + hc.charAt((n >> (j * 8)) & 0x0F); return s }
  function ad(x, y) { const l = (x & 0xFFFF) + (y & 0xFFFF); const m = (x >> 16) + (y >> 16) + (l >> 16); return (m << 16) | (l & 0xFFFF) }
  function rl(n, c) { return (n << c) | (n >>> (32 - c)) }
  function cm(q, a, b, x, s, t) { return ad(rl(ad(ad(a, q), ad(x, t)), s), b) }
  function ff(a, b, c, d, x, s, t) { return cm((b & c) | ((~b) & d), a, b, x, s, t) }
  function gg(a, b, c, d, x, s, t) { return cm((b & d) | (c & (~d)), a, b, x, s, t) }
  function hh(a, b, c, d, x, s, t) { return cm(b ^ c ^ d, a, b, x, s, t) }
  function ii(a, b, c, d, x, s, t) { return cm(c ^ (b | (~d)), a, b, x, s, t) }
  function sb(x) {
    let i; const nblk = ((x.length + 8) >> 6) + 1; const blks = new Array(nblk * 16); for (i = 0; i < nblk * 16; i++) blks[i] = 0
    for (i = 0; i < x.length; i++) blks[i >> 2] |= x.charCodeAt(i) << ((i % 4) * 8)
    blks[i >> 2] |= 0x80 << ((i % 4) * 8); blks[nblk * 16 - 2] = x.length * 8; return blks
  }
  let i; const x = sb('' + inputString); let a = 1732584193; let b = -271733879; let c = -1732584194; let d = 271733878; let olda; let oldb; let oldc; let oldd
  for (i = 0; i < x.length; i += 16) {
    olda = a; oldb = b; oldc = c; oldd = d
    a = ff(a, b, c, d, x[i + 0], 7, -680876936); d = ff(d, a, b, c, x[i + 1], 12, -389564586); c = ff(c, d, a, b, x[i + 2], 17, 606105819)
    b = ff(b, c, d, a, x[i + 3], 22, -1044525330); a = ff(a, b, c, d, x[i + 4], 7, -176418897); d = ff(d, a, b, c, x[i + 5], 12, 1200080426)
    c = ff(c, d, a, b, x[i + 6], 17, -1473231341); b = ff(b, c, d, a, x[i + 7], 22, -45705983); a = ff(a, b, c, d, x[i + 8], 7, 1770035416)
    d = ff(d, a, b, c, x[i + 9], 12, -1958414417); c = ff(c, d, a, b, x[i + 10], 17, -42063); b = ff(b, c, d, a, x[i + 11], 22, -1990404162)
    a = ff(a, b, c, d, x[i + 12], 7, 1804603682); d = ff(d, a, b, c, x[i + 13], 12, -40341101); c = ff(c, d, a, b, x[i + 14], 17, -1502002290)
    b = ff(b, c, d, a, x[i + 15], 22, 1236535329); a = gg(a, b, c, d, x[i + 1], 5, -165796510); d = gg(d, a, b, c, x[i + 6], 9, -1069501632)
    c = gg(c, d, a, b, x[i + 11], 14, 643717713); b = gg(b, c, d, a, x[i + 0], 20, -373897302); a = gg(a, b, c, d, x[i + 5], 5, -701558691)
    d = gg(d, a, b, c, x[i + 10], 9, 38016083); c = gg(c, d, a, b, x[i + 15], 14, -660478335); b = gg(b, c, d, a, x[i + 4], 20, -405537848)
    a = gg(a, b, c, d, x[i + 9], 5, 568446438); d = gg(d, a, b, c, x[i + 14], 9, -1019803690); c = gg(c, d, a, b, x[i + 3], 14, -187363961)
    b = gg(b, c, d, a, x[i + 8], 20, 1163531501); a = gg(a, b, c, d, x[i + 13], 5, -1444681467); d = gg(d, a, b, c, x[i + 2], 9, -51403784)
    c = gg(c, d, a, b, x[i + 7], 14, 1735328473); b = gg(b, c, d, a, x[i + 12], 20, -1926607734); a = hh(a, b, c, d, x[i + 5], 4, -378558)
    d = hh(d, a, b, c, x[i + 8], 11, -2022574463); c = hh(c, d, a, b, x[i + 11], 16, 1839030562); b = hh(b, c, d, a, x[i + 14], 23, -35309556)
    a = hh(a, b, c, d, x[i + 1], 4, -1530992060); d = hh(d, a, b, c, x[i + 4], 11, 1272893353); c = hh(c, d, a, b, x[i + 7], 16, -155497632)
    b = hh(b, c, d, a, x[i + 10], 23, -1094730640); a = hh(a, b, c, d, x[i + 13], 4, 681279174); d = hh(d, a, b, c, x[i + 0], 11, -358537222)
    c = hh(c, d, a, b, x[i + 3], 16, -722521979); b = hh(b, c, d, a, x[i + 6], 23, 76029189); a = hh(a, b, c, d, x[i + 9], 4, -640364487)
    d = hh(d, a, b, c, x[i + 12], 11, -421815835); c = hh(c, d, a, b, x[i + 15], 16, 530742520); b = hh(b, c, d, a, x[i + 2], 23, -995338651)
    a = ii(a, b, c, d, x[i + 0], 6, -198630844); d = ii(d, a, b, c, x[i + 7], 10, 1126891415); c = ii(c, d, a, b, x[i + 14], 15, -1416354905)
    b = ii(b, c, d, a, x[i + 5], 21, -57434055); a = ii(a, b, c, d, x[i + 12], 6, 1700485571); d = ii(d, a, b, c, x[i + 3], 10, -1894986606)
    c = ii(c, d, a, b, x[i + 10], 15, -1051523); b = ii(b, c, d, a, x[i + 1], 21, -2054922799); a = ii(a, b, c, d, x[i + 8], 6, 1873313359)
    d = ii(d, a, b, c, x[i + 15], 10, -30611744); c = ii(c, d, a, b, x[i + 6], 15, -1560198380); b = ii(b, c, d, a, x[i + 13], 21, 1309151649)
    a = ii(a, b, c, d, x[i + 4], 6, -145523070); d = ii(d, a, b, c, x[i + 11], 10, -1120210379); c = ii(c, d, a, b, x[i + 2], 15, 718787259)
    b = ii(b, c, d, a, x[i + 9], 21, -343485551); a = ad(a, olda); b = ad(b, oldb); c = ad(c, oldc); d = ad(d, oldd)
  }
  return rh(a) + rh(b) + rh(c) + rh(d)
}
